<template>
  <article>
   <div class="filter mt-20 mb-20">
    </div>
    <el-table ref="dataTable" :data="lists" highlight-current-row v-loading="listLoading" style="width: 100%;" class="" height="700">
      <el-table-column prop="gsid" label="库存ID" width="" align="center" sortable>
      </el-table-column>
      <el-table-column prop="sgid" label="商品" width="" align="center">
        <template slot-scope="scope">
          <div>{{scope.row.title}}({{scope.row.sgid}})</div>
        </template>
      </el-table-column>
      <el-table-column prop="category_key" label="特征ID" width="" align="center" sortable>
      </el-table-column>
      <el-table-column prop="category" label="特征名" width="" align="center" sortable>
      </el-table-column>
      <el-table-column prop="feature_key" label="属性ID" width="" align="center" sortable>
      </el-table-column>
      <el-table-column prop="content" label="属性名" width="" align="center" sortable>
      </el-table-column>
      <el-table-column prop="total" label="总量" width="" align="center">
        <template slot-scope="scope">
          <div class="flex jcc">
            <el-input v-model="scope.row.total" placeholder="" size="mini" class="dataForm__input"></el-input>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="sold" label="已售" width="" align="center">
      </el-table-column>
      <el-table-column label="操作" width="180" align="center" fixed="right">
        <template slot-scope="scope">
          <div class="flex jcc">
            <button class="blue-small-btn" @click="shopGoodsStockEdit(scope.$index)">保存</button>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </article>
</template>
<script>
import util from '../../../script/util'
import {shopGoodsLists, shopGoodsStockFullLists, shopGoodsStockEdit} from '../../../api/api'
import uploadHeadImage from '../../../components/uploadImage.vue'
export default {
  name: 'shopGoodsStock',
  components: {
    uploadHeadImage
  },
  data () {
    return {
      sgid: '',
      lists: [],
      goodsLists: [],
      listLoading: false,
      detail: {
        gsid: 0,
        category_key: '',
        category: '',
        feature_key: '',
        content: '',
        layer: '',
        total: ''
      }
    }
  },
  methods: {
    handleSizeChange (val) {
      this.filters.l = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.filters.p = val
      this.getList()
    },
    // 格式化时间
    formatTimeStamp (time) {
      return util.formatTimeStamp(time)
    },
    shopGoodsStockEdit (index) {
      let params = {
        gsid: this.lists[index]['gsid'],
        sgid: this.sgid,
        category_key: this.lists[index]['category_key'],
        category: this.lists[index]['category'],
        feature_key: this.lists[index]['feature_key'],
        content: this.lists[index]['content'],
        layer: this.lists[index]['layer'],
        total: this.lists[index]['total']
      }

      shopGoodsStockEdit(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '保存成功',
            type: 'success'
          })
          this.detailDialog = false
          this.getList()
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      })
    },
    getList () {
      let params = {
        sgid: this.sgid
      }

      this.listLoading = true
      shopGoodsStockFullLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.lists = data.d.lists
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
        this.$notify({
          title: '失败',
          message: '服务器出错了',
          type: 'error'
        })
      })
    },
    getGoodsLists () {
      let params = {
      }

      this.listLoading = true
      shopGoodsLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.goodsLists = data.d.lists.map((item, index) => {
            return {
              title: item.title + '(' + item.sgid + ')',
              sgid: item.sgid
            }
          })
          this.goodsLists.unshift({
            title: '所有',
            sgid: ''
          })
        }
      })
    }
  },
  mounted () {
    this.sgid = parseInt(this.$route.query.sgid || 0)
    this.getGoodsLists()
    this.getList()
  },
  updated () {
    this.$nextTick(() => {
      this.$refs['dataTable'].doLayout()
      this.$refs['dataTable'].bodyWrapper.scrollTop = 0
    })
  },
  watch: {
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/module/shop/shopGoodsStockFull.vue